export default "__VITE_ASSET__BTfI6PiS__"